<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.refund">
    <app-popup-header title="{{localService.languageContent.refund.title}}"></app-popup-header>
    <div class="modal-body">
        <div class="row">
            <div class="col-3">
                <app-label [Text]="localService.languageContent.refund.upi" [IsMandatory]="true"></app-label>
            </div>
            <div class="col-9">
                <input id="{{elementIds.txt_refund_upi}}" autocomplete="off" type="text" [(ngModel)]="strUpi"
                    placeholder="*{{localService.languageContent.refund.upi}}"
                    title="*{{localService.languageContent.refund.upi}}" [ngClass]="strUpi != '' ? 'en' : ''" />
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <app-label [Text]="localService.languageContent.refund.amount" [IsMandatory]="true"></app-label>
            </div>
            <div class="col-9">
                <input autocomplete="off" type="number" class="number"
                    (keypress)="localService.isNumberOnly($event,numericConfig)" id="{{elementIds.txt_refund_amount}}"
                    [(ngModel)]="dblAmount" style="width:100%;text-align: left;"
                    placeholder="*{{localService.languageContent.refund.amount}}"
                    title="*{{localService.languageContent.refund.amount}}" [ngClass]="dblAmount != null ? 'en' : ''" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <app-label [Text]="localService.languageContent.refund.payment_id" [IsMandatory]="true"></app-label>
            </div>
            <div class="col-md-8">
                <input id="{{elementIds.txt_refund_payment_id}}" autocomplete="off" type="text" [(ngModel)]="paymentId"
                    placeholder="*{{localService.languageContent.refund.payment_id}}"
                    title="*{{localService.languageContent.refund.payment_id}}"
                    [ngClass]="paymentId != '' ? 'en' : ''" />
            </div>
        </div>
        <div>
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.refund.notes"></app-label>
                </div>
                <div>
                    <textarea id="{{elementIds.txt_refund_notes}}" rows="5" style="width: 100%;" [(ngModel)]="notes"
                        title="{{localService.languageContent.refund.notes}}"
                        placeholder="{{localService.languageContent.refund.notes}}"></textarea>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="row" style="width: 100%;">
                <div class="col-6">
                    <a class="button" (click)="onPopupClose()"
                        [routerLink]="['/refund' + localService.basicParamsString,countryCode,interactionType,userOrBusinessId]">{{localService.languageContent.refund.show_history}}</a>
                </div>
                <div class="col-6" style="text-align: right;">
                    <button type="button" class="btn btn-primary" id="{{elementIds.txt_refund_save}}"
                        (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
                </div>
            </div>
        </div>
    </div>